import { definePreset } from "@primeuix/themes";
import Aura from "@primeuix/themes/aura";

export const VoltexploitPreset = definePreset(Aura, {
  semantic: {
    primary: {
      50: "#f0f9ff",
      100: "#e0f1fe",
      200: "#bbe4fc",
      300: "#7ecffb",
      400: "#4dbef7",
      500: "#109ee7",
      600: "#047ec5",
      700: "#05659f",
      800: "#085684",
      900: "#0d476d",
      950: "#092d48",
    },
  },
});
